<template>
  <div>
    <header>
      <b-navbar toggleable="md" class="p-0">
        <b-container fluid class="outer">
          <b-navbar-brand href="#" :to="homeURL">
            <div class="img-holder">
              <img src="@/assets/img/compass-logo.svg" alt="" width="200">
            </div>
            <span class="version-holder">{{ $store.getters.appVersion }}</span>
          </b-navbar-brand>

          <div v-if="!noMenu" class="right-part">

            <notification class="notification-box"></notification>

            <b-collapse is-nav id="nav_collapse" class="outer container-fluid">

              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">

                <b-nav-item-dropdown class="nc-dropdown flex-grow-1"
                                     right no-caret >
                  <div slot="button-content" class="d-flex flex-grow-1 justify-content-between align-items-start">
                    <div class="nc-avatar-holder">
                      <div class="client-logo-holder" v-if="isClient">
                        <div class="client-logo" v-if="userPicture">
                          <img :src="userPicture" alt="">
                        </div>
                        <div class="mr-3 nc-user-name" v-else>{{userName}} <span v-if="!isClient" class="nc-user-role text-muted" v-html='userRole'></span></div>
                      </div>
                      <div class="user-avatar" v-else>
                        <img :src="userPicture" alt="">
                      </div>
                      <div class="d-none d-md-flex align-items-center"><i class="icon-bracket-down"></i></div>
                    </div>
                  </div>
                  <b-dropdown-item to="holidays" v-if="!isClient">Holidays</b-dropdown-item>
                  <b-dropdown-item @click="logout">Logout</b-dropdown-item>
                </b-nav-item-dropdown>

              </b-navbar-nav>

            </b-collapse>

            <b-button v-b-toggle.nav_collapse variant="light" class="button-close"><i class="icon-close"></i></b-button>
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          </div>
        </b-container>

      </b-navbar>


    </header>
  </div>
</template>

<script>
import helpers from '../_mixins/helpers';

export default {
  name: 'Header',
  components: {
    'notification': () => import('@/components/Notification.vue'),
  },
  data: () => ({
    counterLoading: false,
    updateRDsProgress: 0,
    interval: null,
    progressInfo: {
      progress: 0,
      max: 100,
      operation: '',
    },
  }),
  mixins: [helpers],
  props: {
    home: {
      type: String
    },
    noMenu: {
      type: Boolean,
      default: false
    },
    clientView: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    logout() {
      this.$store.dispatch('authentication/logout');
    },
  },
  computed: {
    homeURL() {
      if (this.home) {
        return this.home;
      }
      return this.noMenu?'':'/';
    },
    user() {
      return this.$store.state.authentication.user;
    },
    userRole() {
      // console.log('this.user',this.user);
      if (this.user.isAdmin) {
        return `<br>Admin`;
      } else {
        return `<br>User`;
      }
    },
    userPicture() {
      // console.log('this.user',this.user);
      if (this.isClient) {
        return this.addImgAddress(this.user.client_small_logo);
      } else {
        return this.user.picture;
      }
    },
    isClient() {
      return this.user && this.user.login_type===1;
    },
    userName() {
      if (this.isClient) {
        return this.user.client_name;
      } else {
        return this.user.name;
      }
    }
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';
@import '../assets/_scss/components/header';

header /deep/ {
  @import '../assets/_scss/components/dropdown-menu';

}
.right-part {
  display: flex;
  align-items: center;
}
.navbar-brand {
  display: flex;
  align-items: flex-end;
  @include sm {
    flex-basis: 100%;
  }
  .version-holder {
    font-size: 10px;
    padding-left: 10px;
  }
}
.client-logo-holder {
  display: flex;
  align-items: center;
}
/deep/ .nav-link.dropdown-toggle {
  padding-right: 0;
}


.nav-link.dropdown-toggle {
  &[aria-expanded="true"] {
    .icon-bracket-down {
      transform: rotate(180deg);
    }
  }
}

.icon-bracket-down {
  font-size: 6px;
  display: inline-block;
  transition: .3s;
}

.notification-box {
  display: flex;
  margin: auto 20px;
  position: relative;
  @include sm {
    position: absolute;
    top: 20px;
    right: 30px;
  }
}
</style>
